export const SELLER_PROFILE_IMAGE_WC_WINNER_ARGENTINA =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/704d77334bf2c3d157c162f8346baaee-1784300236617/argentina_448x448.png';

export const SELLER_PROFILE_IMAGE_WC_WINNER_SPAIN =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/1389abe50d0f58d769dc466e36614403-1784300218686/spain_448x448.png';
